__turbopack_context__.v({
  "full": "live-device-module__tJkQbq__full",
  "waiting": "live-device-module__tJkQbq__waiting",
  "word": "live-device-module__tJkQbq__word",
});
